import APIClient from '../factories/APIClient'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Explore.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /merchants': 200,
    // 'get /merchants*': 422,
    // 'get /stores/details': 200,
    // 'get /stores/*': 200,
    // 'get /stores': 200,
    // 'get /search': 200,
    // 'get /display/shop*': 200,
    // 'get /display/dine*': 422,
    // 'get /display/unwind*': 422,
    // 'get /display/featured?type=0*': 200,
    // 'get /display/featured?type=1*': 200,
    // 'get /display/featured?type=2*': 200,
    // 'get /participating-stores': 200
    // 'get /events/*/arcticles': 200,
    // 'get /popup-modals': 200,
  })
}

const cacheControl = { 'Cache-Control': 'max-age=0' }
